import styled from 'styled-components';

const Sidenav = styled.div`
  height: fit-content;
  border-radius: 10px;
  position: fixed;
  /* position: ${({ scroll }) => (scroll ? 'fixed' : 'inherit')}; */
  .sidenav-container {
    border-radius: 10px;
  }
`;

const AppStoreContainer = styled.div`
  display: flex;
  padding: 40px 40px 10px 20px;
  .appstore-download-container {
    width: 250px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-right: 20px;
  }
  .appstore-img-container {
    max-width: 500px;
  }
  .appstore-img {
    max-width: 500px;
  }
  .appstore-download-img {
    cursor: pointer;
    color: #000;
    margin-top: 12px;
    &:hover {
      color: #4C4C4C;
    }
  }
  .company-brand {
    display: flex;
    align-items: center;
    z-index: 1;
    svg {
      width: 33px;
      height: 33px;
    }
    .logo-title {
      color: #2b99f5;
      font-size: 28px;
      text-align: start;
      margin-left: 8px;
      font-weight: 600;
    }
  }
  .appstore-helper-text {
    font-size: 12.5px;
    color: #7f7f7f;
  }
  @media only screen and (max-width: 899px) {
    flex-direction: column;
    align-items: center;
    .appstore-download-container {
      width: auto;
    }
    .appstore-img-container {
      width: 100%;
      margin-top: 30px;
    }
    .appstore-img {
      width: 100%;
      max-width: 500px;
    }
  }
`;

const CreateButton = styled.div`
  margin-top: 30px;
  margin-bottom: 24px;
  .post-btn {
    border-radius: 32px;
    height: 47px;
    border: 1px solid #dbdbdb;
    padding: 0px 15px;
    &:hover {
      background: #ffc61b;
    }
    .create-post {
      display: flex;
      font-size: 19px;
      font-weight: 700;
      justify-content: center;
      align-items: center;
      span {
        margin-right: 15px;
      }
    }
  }
`;

const MenuItem = styled.div`
  .menu-list {
    display: flex;
    align-items: center;
    padding: 10px 15px 10px 10px;
    margin-bottom: 5px;
    font-size: 16px;
    color: ${({ theme }) => theme.text1};
    font-weight: 500;
    text-decoration: none;
    position: relative;
    svg {
      margin-right: 15px;
      fill: ${({ theme }) => theme.text1};
    }
    &:hover {
      background-color: ${({ theme }) => theme.hoverBg1};
      border-radius: 100px;
    }
  }
  .notification-count {
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 4px;
    left: 20px;
    font-size: 12px;
    font-weight: 600;
    color: #fff;
    background-color: ${({ theme }) => theme.red1};
    border-radius: 50px;
  }
  .active-menu {
    color: ${({ theme }) => theme.colors[4]};
    .home-filled path {
      fill: ${({ theme }) => theme.colors[4]};
    }
    svg {
      fill: ${({ theme }) => theme.colors[4]};
    }
  }
`;

export { Sidenav, CreateButton, MenuItem, AppStoreContainer };
